import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from '../index';

/*
    querySelected,
    soilProfileSelected,
    soilAnalysesSelected,
    templateUpdateSelected,
    referenceDataSelected,
    userManagementSelected
*/

interface IMenuSelectedModel {
    currentSelected: 'QUERY' | 'PROFILE' | 'ANALYSES' | 'TEMPLATE'
                    | 'REFERENCE' | 'MANAGEMENT' | 'SOILHISTORY'
}

const initialState: IMenuSelectedModel = {
    currentSelected: 'QUERY'
};

export const menuSelectedSlice = createSlice({
    name: 'soilMenuSelected',
    initialState,
    reducers: {
        select: (state, action: PayloadAction<IMenuSelectedModel>) => {
            return {
                currentSelected: action.payload.currentSelected
            };
        }
    }
});

export type {
    IMenuSelectedModel
};

export const {
    select
} = menuSelectedSlice.actions;

export const menuCurrentSelected = (state: RootState) => state.menuSelected;
export default menuSelectedSlice.reducer;